import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-home-page',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.css'],

})
export class PrivacyComponent implements OnInit {

  constructor(private router:Router) {


  }
  ngOnInit() {
  }

  goToDiv(fragment) {
    let tree = this.router.parseUrl(this.router.url);
    if (tree.fragment == fragment) {
      let element = document.querySelector("#" + tree.fragment);
      if (element) {
        // @ts-ignore
        element.scrollIntoView(element);
      }
    }
    else {
      this.router.navigate(['/privacy/'], {fragment: fragment})
        .then( () => {
          let tree = this.router.parseUrl(this.router.url);
          let element = document.querySelector("#" + tree.fragment);
          if (element) {
            // @ts-ignore
            element.scrollIntoView({ behavior: 'smooth' });
          }
        });
    }
  }
}
